import { Component } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { firstValueFrom } from 'rxjs';
import { GenericCrudAddComponent } from 'src/app/libs/components/generic-crud/generic-crud-add.component';
import { BatchExpense, ProductBatch, TId } from 'src/app/models';
import { ValueChangedEvent } from 'devextreme/ui/lookup';

@Component({
    selector: 'app-batch-expenses-add',
    templateUrl: './batch-expenses-add.component.html',
    styleUrl: './batch-expenses-add.component.sass',
    standalone: false
})
export class BatchExpensesAddComponent extends GenericCrudAddComponent<BatchExpense> {


  productsRes = this.api.resources.product.products
  organizationsRes = this.api.resources.organization.organizations;

  override initFormGroup(): FormGroup {
    const form = this.fb.group({
      description: [],
      productId: [this.initialFormValues?.productId],
      productBatchId: [this.initialFormValues?.productBatchId],
      reference: [],
      organizationId: [],
      cost: [],
      date: [new Date()],
      companyId: [this.api.auth.userValue?.lastCompanyId]
    });
    return form;
  }
}
